<template>
  <div class="content_main">
    <p class="content_normal">We act as Solicitors to CASHIGO INTERNATIONAL LIMITED, who will shall
      hereafter refer to as Our Client and on whose instruction we now write.</p>
    <br />
    <p class="content_normal">Since the loan you are currently applying for on our platform LCredit
      has been overdue for more than 11 days, our recovery team has been trying to contact you to
      negotiate the loan, but cannot contact you. Our company initially judged that you were unable
      to repay the loan, and suspected that if you try to deceive the company and maliciously
      default on the loan, our company has the right to freeze your bank account and Bvn.</p>
    <br />
    <p class="content_normal">The company will also call your friends and family to report the
      situation to them.</p>
    <br />
    <p class="content_normal"> In order to avoid affecting your reputation, please repay the loan as
      soon as possible after receiving the notice or contact us. If you have financial difficulties,
      we can apply for a 30% penalty interest reduction for you. After you have completed the
      repayment, if there is still a need for borrowing, you can apply for another loan</p>
    <br />
    <p class="content_normal">After receiving the information, please contact my whatsapp:
      08120570894</p>
    <p class="content_normal">Email: lcredit@firchinternational.com</p>
    <br />
    <p class="content_normal">Therefore, this letter requires you to pay and return it to the mail
      or company immediately.</p>
    <br />
    <p class="content_normal">Regards. Therefore, this letter requires you to pay and return it to
      the mail or company immediately.</p>
    <br />
    <p class="content_normal">Note: If you fail to pay, we will use all available methods to seek
      justice, which will obviously make you pay more.</p>
    <br />
    <p class="content_normal">While waiting for your prompt reply, do have t assurance of our best
      regards.</p>
    <br />
    <p class="content_normal">Regards.</p>
  </div>
</template>

<script>
export default {
  name: 'M3',
};
</script>

<style lang="stylus" scoped>
px = (1 / 24.75vw);
.content {
  padding: 25 *px 16 *px;
  .content_main{
    line-height: 20px;
    text-indent: 16px;
    margin-top: 16px;
  }
  .content_normal {
    text-align: left;
    text-indent: 16px;
  }
}
</style>
